import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_page_category_testimonial-click';

/**
 * track brand page category testimonial click
parameter is the category name
 */
export function trackBrandLeadsBrandsPageCategoryTestimonialClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
